<template lang="pug">
  card-info.height-100.filiation-subscriptions(title="Assinaturas com o link" icon="fas fa-dollar-sign")
    .card-body(slot="card-body")
      list-manager(:loading="loading" :error="error" :paginated-list="list" @fetch-data="fetchData")
        .table-responsive(v-if="list && list.rows.length > 0")
          table.table.table-striped.table-hover
            thead
              tr
                th Hora da assinatura
                th Plano
                th Percentual ganho
                th Lucro
                th.text-right Ações
            tbody
              tr(v-for="row in list.rows")
                td {{ row.subscription.createdAt | toDate('DD/MM/YYYY')  }}
                td {{ row.subscription.plan.description  }}
                td {{ row.percentage | currency('', '%')  }}
                td
                  .text-bold.text-success {{ row.amount | currency('R$ ') }}
                td.text-right
                  router-link.btn.btn-link.btn-xs.btn-action(:to="{ name: 'subscriptions.show', params: { id: row.subscription.id } }")
                    i.fas.fa-eye
</template>

<script>
import filiations from '@/services/filiations'

export default {
  props: { filiation: { type: Object, required: true }, q: { type: Object } },

  data() {
    return { list: null, loading: false, error: null }
  },

  methods: {
    async fetchData(params = {}) {
      try {
        this.loading = true
        const { id } = this.filiation
        const query = { ...params, q: this.q }
        const { data } = await filiations.filiationSubscriptions(id, query)
        this.list = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.fetchData()
  },
}
</script>

<style lang="stylus">
.filiation-subscriptions
  .empty
    background #fff
  .content-full-height
    height auto
</style>
